import React from 'react';
import { GameSummary } from '../types';

interface GameHistoryProps {
  games: GameSummary[];
  onSelect: (gameId: string) => void;
}

const formatDate = (timestamp?: number) => {
  if (!timestamp) return '';
  const date = new Date(timestamp * 1000);
  return date.toLocaleString();
};

const GameHistory: React.FC<GameHistoryProps> = ({ games, onSelect }) => {
  return (
    <div className="panel">
      <h3>History</h3>
      <div className="history-list">
        {games.length === 0 && (
          <div className="notice">No games yet. Start a new one to begin.</div>
        )}
        {games.map((game) => (
          <div
            key={game.uuid}
            className="history-item"
            onClick={() => onSelect(game.uuid)}
            role="button"
            tabIndex={0}
          >
            <div>
              <div className="badge">{game.difficulty}</div>
              <div style={{ marginTop: 6 }}>{formatDate(game.created_at)}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div>{game.status.toUpperCase()}</div>
              <div style={{ color: 'var(--theme-muted)' }}>{game.guess_count}/{game.max_guesses}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GameHistory;
